import { useMemo } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { AutomationFormBaseFields } from "../../AutomationsUtils";

export interface AutomationURLDataReturn
  extends Pick<AutomationFormBaseFields, "filter" | "scope"> {}

export const useAutomationURLData = (): AutomationURLDataReturn | undefined => {
  const { search } = useLocation();
  const history = useHistory();

  return useMemo(() => {
    if (!!search) {
      const params = new URLSearchParams(search);
      const filtersid = params.get("filtersid");
      const scopesid = params.get("scopesid");
      const filtersjson = params.get("filtersjson");
      const filterslabel = params.get("filterslabel");

      // Clear the search params after getting the data to prevent collisions
      history.replace({ search: "" });

      let filter;
      if (filtersid) {
        filter = {
          value: {
            id: filtersid,
          },
        };
      } else if (filtersjson && filterslabel) {
        filter = {
          label: filterslabel,
          value: {
            query: filtersjson,
          },
        };
      }

      let scope;
      if (scopesid) {
        scope = {
          value: {
            id: scopesid,
          },
        };
      }

      return {
        filter,
        scope,
      };
    }
  }, [search, history]);
};

export default useAutomationURLData;
